import React, { useState, useEffect, useMemo } from "react";
import { Plus, Pencil, X, Search, Smartphone } from "lucide-react";
import { api } from "../../utils/api";
import PageHead from "../../components/PageHead";

// Para ve Tarih formatlayıcı araçlar
const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);
const fmt = d => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function Owners() {
  const [owners, setOwners] = useState([]);
  const [q, setQ] = useState("");
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);

  // Malikleri yükle ve isme göre sırala
  const load = () => api.get("/owners").then(r => setOwners((r.data || []).sort((a, b) => (a.owner_name || "").localeCompare(b.owner_name || "", "tr"))));
  
  useEffect(() => { 
    load(); 
  }, []);

  // Arama filtresi
  const visible = useMemo(() => owners.filter(x => 
    ((x.villa_no || "") + (x.accounting_code || "") + (x.owner_name || "")).toLowerCase().includes(q.toLowerCase())
  ), [owners, q]);

  // WhatsApp Davet Fonksiyonu
  const sendWhatsAppInvite = async (accounting_code, role) => {
    try {
      const res = await api.post("/resident/generate-link", { accounting_code, role });
      const { link, phone, name } = res.data;
      
      let cleanPhone = phone.replace(/\D/g, ''); 
      if (cleanPhone.startsWith("0")) cleanPhone = "90" + cleanPhone.slice(1);
      else if (!cleanPhone.startsWith("90")) cleanPhone = "90" + cleanPhone;
      
      const text = `Merhaba ${name},\nBaşkent Sitesi mobil yönetim paneline giriş yapmak ve aidatlarınızı takip etmek için lütfen aşağıdaki linke tıklayarak kendi şifrenizi belirleyin:\n\n${link}`;
      
      const waUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(text)}`;
      window.open(waUrl, "_blank");
      
    } catch(e) {
      alert(e.response?.data?.detail || "İşlem başarısız. Lütfen numarayı kontrol edin.");
    }
  };

  // Malik Silme
  const remove = async (x) => {
    if (!window.confirm(`${x.owner_name || x.accounting_code} kaydını silmek istediğinize emin misiniz?`)) return;
    await api.delete(`/owners/${x.accounting_code}`);
    load();
  };

  // Yeni Kayıt veya Düzeltme Sonrası Tetiklenen İşlem
  const onSaved = () => {
    setEditing(null);
    setCreating(false);
    load();
  };

  return (
    <>
      <PageHead 
        eyebrow="SİTE SAKİNLERİ" 
        title="Malik ve Kiracı Hesapları" 
        sub="Sitedeki tüm malik ve kiracı bilgilerini yönetebilir, WhatsApp ile sisteme davet edebilirsiniz." 
        action={
          <button className="primary" onClick={() => setCreating(true)}>
            <Plus size={17}/> Yeni Malik Ekle
          </button>
        }
      />

      <section className="panel table-panel">
        <div style={{ padding: "16px", borderBottom: "1px solid #eee" }}>
          <div style={{ display: "flex", alignItems: "center", background: "#f8fafc", padding: "8px 12px", borderRadius: "8px" }}>
            <Search size={16} color="#64748b" style={{ marginRight: "8px" }} />
            <input 
              type="text" 
              placeholder="Villa no, isim veya hesap kodu ile ara..." 
              value={q} 
              onChange={e => setQ(e.target.value)}
              style={{ border: "none", background: "transparent", outline: "none", width: "100%" }}
            />
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>VİLLA</th>
              <th>HESAP KODU</th>
              <th>MALİK (EV SAHİBİ)</th>
              <th>KİRACI (OTURAN)</th>
              <th className="right">İŞLEM</th>
            </tr>
          </thead>
          <tbody>
            {visible.map(x => (
              <tr key={x.accounting_code}>
                <td><strong>{x.villa_no}</strong></td>
                <td>{x.accounting_code}</td>
                
                {/* MALİK SÜTUNU */}
                <td>
                  <div>{x.owner_name || "—"}</div>
                  <small style={{ color: "#64748b" }}>{x.owner_phone || "Telefon yok"}</small>
                  <button 
                    onClick={() => x.owner_phone ? sendWhatsAppInvite(x.accounting_code, "owner") : alert("Davet göndermek için yandaki Kalem (Düzelt) butonuna basarak bir telefon numarası ekleyin.")} 
                    style={{ fontSize: "11px", color: x.owner_phone ? "#10b981" : "#94a3b8", background: "none", border: "none", cursor: "pointer", padding: 0, marginTop: "4px", display: "flex", alignItems: "center", gap: "4px" }}
                  >
                    <Smartphone size={12}/> Davet Et
                  </button>
                </td>
                
                {/* KİRACI SÜTUNU */}
                <td>
                  <div>{x.resident_name || "—"}</div>
                  <small style={{ color: "#64748b" }}>{x.resident_phone || "Telefon yok"}</small>
                  <button 
                    onClick={() => x.resident_phone ? sendWhatsAppInvite(x.accounting_code, "tenant") : alert("Davet göndermek için yandaki Kalem (Düzelt) butonuna basarak bir telefon numarası ekleyin.")} 
                    style={{ fontSize: "11px", color: x.resident_phone ? "#3b82f6" : "#94a3b8", background: "none", border: "none", cursor: "pointer", padding: 0, marginTop: "4px", display: "flex", alignItems: "center", gap: "4px" }}
                  >
                    <Smartphone size={12}/> Davet Et
                  </button>
                </td>
                
                <td className="right">
                  <div className="row-actions">
                    <button className="icon" title="Düzenle" onClick={() => setEditing(x)}><Pencil size={14}/></button>
                    <button className="icon danger" title="Sil" onClick={() => remove(x)}><X size={15}/></button>
                  </div>
                </td>
              </tr>
            ))}
            {!visible.length && (
              <tr><td colSpan="5" className="empty" style={{ textAlign: "center", padding: "20px" }}>Kayıt bulunamadı.</td></tr>
            )}
          </tbody>
        </table>
      </section>

      {creating && <OwnerModal onClose={() => setCreating(false)} onSaved={onSaved} />}
      {editing && <OwnerModal row={editing} onClose={() => setEditing(null)} onSaved={onSaved} />}
    </>
  );
}

function OwnerModal({ row, onClose, onSaved }) {
  const [form, setForm] = useState(row || { villa_no: "", accounting_code: "", owner_name: "", owner_phone: "", resident_name: "", resident_phone: "" });
  const [loading, setLoading] = useState(false);

  const change = e => setForm({ ...form, [e.target.name]: e.target.value });

  const save = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      if (row) {
        await api.put(`/owners/${row.accounting_code}`, form);
      } else {
        await api.post("/owners", form);
      }
      onSaved();
    } catch (x) {
      alert(x.response?.data?.detail || "Kayıt başarısız oldu.");
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <div className="modal-head">
          <div>
            <span className="eyebrow">{row ? "KAYDI GÜNCELLE" : "YENİ KAYIT"}</span>
            <h2>{row ? form.accounting_code : "Yeni Malik"}</h2>
          </div>
          <button type="button" className="icon" onClick={onClose}><X size={18}/></button>
        </div>
        <form onSubmit={save}>
          <div className="form-grid">
            <label>Villa No <input name="villa_no" required value={form.villa_no} onChange={change} /></label>
            <label>Hesap Kodu <input name="accounting_code" required value={form.accounting_code} onChange={change} disabled={!!row} /></label>
          </div>
          <label>Malik (Ev Sahibi) Adı <input name="owner_name" value={form.owner_name} onChange={change} /></label>
          <label>Malik Telefon <input name="owner_phone" placeholder="05XX..." value={form.owner_phone} onChange={change} /></label>
          
          <div style={{ margin: "16px 0", borderTop: "1px dashed #eee" }}></div>
          
          <label>Kiracı (Oturan) Adı <input name="resident_name" value={form.resident_name} onChange={change} /></label>
          <label>Kiracı Telefon <input name="resident_phone" placeholder="05XX..." value={form.resident_phone} onChange={change} /></label>
          <div style={{ margin: "16px 0", borderTop: "1px dashed #eee" }}></div>
          
          <label>Ödeme Yapan Adı <input name="payer_name" value={form.payer_name} onChange={change} /></label>
          
          <div className="modal-actions">
            <button type="button" className="secondary" onClick={onClose}>İptal</button>
            <button type="submit" className="primary" disabled={loading}>{loading ? "Kaydediliyor..." : "Kaydet"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}